import "./RecentWork.css";
import { useRef } from "react";
import shikhar from "../../Images/RecentWork/Shikhar.png";
import ekchina from "../../Images/RecentWork/EkChihan.png";

const RecentWork = () => {
  const containerRef = useRef(null);
  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const onMouseDown = (e) => {
    isDown.current = true;
    containerRef.current.classList.add("dragging");
    startX.current = e.pageX;
    scrollLeft.current = containerRef.current.scrollLeft;
  };

  const onMouseUp = () => {
    isDown.current = false;
    containerRef.current.classList.remove("dragging");
  };

  const onMouseLeave = onMouseUp;

  const onMouseMove = (e) => {
    if (!isDown.current) return;
    e.preventDefault();

    const x = e.pageX;
    const walk = (x - startX.current) * 1.2; // speed control
    containerRef.current.scrollLeft = scrollLeft.current - walk;
  };

  return (
    <div
      className="recentWorkSec"
      ref={containerRef}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      onMouseMove={onMouseMove}
    >
      <div className="recentWorks">
        {[ekchina, shikhar, ekchina, shikhar, ekchina, shikhar].map(
          (img, i) => (
            <div className="recWork" key={i}>
              <img src={img} alt="" draggable={false} />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default RecentWork;
